"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.array.index-of");

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}

function _objectWithoutProperties(e, r) {
  var o = {};

  for (var t in e) {
    r.indexOf(t) >= 0 || Object.prototype.hasOwnProperty.call(e, t) && (o[t] = e[t]);
  }

  return o;
}

function make() {
  return name || (name = (0, _globals.animation)(rule));
}

function Pulse() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : _globals.defaults,
      r = e.children,
      o = (e.out, e.timeout),
      t = e.duration,
      n = void 0 === t ? _globals.defaults.duration : t,
      a = e.delay,
      u = void 0 === a ? _globals.defaults.delay : a,
      l = e.count,
      p = void 0 === l ? _globals.defaults.count : l,
      s = e.forever,
      i = _objectWithoutProperties(e, ["children", "out", "timeout", "duration", "delay", "count", "forever"]),
      d = {
    make: make,
    duration: void 0 === o ? n : o,
    delay: u,
    forever: s,
    count: p,
    style: {
      animationFillMode: "both"
    }
  };

  return (0, _wrap2["default"])(i, d, !1, r, !0);
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var _propTypes = require("prop-types"),
    _wrap = require("./wrap"),
    _wrap2 = _interopRequireDefault(_wrap),
    _globals = require("./globals"),
    propTypes = {
  duration: _propTypes.number,
  timeout: _propTypes.number,
  delay: _propTypes.number,
  count: _propTypes.number,
  forever: _propTypes.bool
},
    rule = "\n\tfrom {\n    transform: scale3d(1, 1, 1);\n  }\n\n  50% {\n    transform: scale3d(1.05, 1.05, 1.05);\n  }\n\n  to {\n    transform: scale3d(1, 1, 1);\n}\n",
    name = !1;

Pulse.propTypes = propTypes, exports["default"] = Pulse, module.exports = exports["default"];